module.exports = __webpack_public_path__ + "static/media/40.69a9af39.mp3";